<template>
  <v-row dense class="pt-0 pb-1">
    <v-col class="py-0">
      <TextFieldInputWithDatePicker
        :label="dateLabel"
        v-model="selectDate"
        :disableFutureDate="disableFutureDatetime"
        :required="required"
        :disabled="disabled"
      />
    </v-col>
    <v-col class="py-0">
      <TextFieldInputWithTimePicker :label="timeLabel" v-model="selectTime" :required="required" :disabled="disabled" />
    </v-col>
  </v-row>
</template>

<script>
import dayjs from 'dayjs'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker'
import TextFieldInputWithTimePicker from '@/components/atoms/base/text-field/TextFieldInputWithTimePicker'

export default {
  name: 'DatetimePicker',

  components: {
    TextFieldInputWithDatePicker,
    TextFieldInputWithTimePicker,
  },
  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    disableFutureDatetime: {
      type: Boolean,
      default: false,
      required: false,
    },
    dateLabel: {
      type: String,
      default: function () {
        return this.$t('ELE0358')
      },
      required: false,
    },
    timeLabel: {
      type: String,
      default: function () {
        return ''
      },
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', `${value.date} ${value.time}:00`)
        // 時分までしか使用しないが、SPARQの時刻フォーマットとそろえるため00追加
      },
    },
    selectDate: {
      get() {
        return dayjs(this.model).format('YYYY-MM-DD')
      },
      set(value) {
        this.model = { date: value, time: this.selectTime }
      },
    },
    selectTime: {
      get() {
        return dayjs(this.model).format('HH:mm')
      },
      set(value) {
        this.model = { date: this.selectDate, time: value }
      },
    },
  },
}
</script>
